import { Dialog } from "primereact/dialog";

export default function AddandEditform ({visible, setVisible, handlesave, handleupdate, formdata,desktopFile, mobileFile, loading, handlechange}) {

    return (
        <>
         <Dialog header="Home Banner Details" visible={visible} onHide={() => setVisible(false)} className="!w-full lg:!w-[40rem]">
                <form onSubmit={!formdata?._id ? handlesave : handleupdate}>
                  <div className='mb-3'>
                        <div className='flex items-center justify-center mb-3'>
                            <div className='mr-4'>
                                <label className="block mb-2 text-sm font-medium">Desktop Image</label>
                                <label className="flex flex-col items-center justify-center object-cover w-40 h-40 overflow-hidden border-2 border-gray-300 border-dashed cursor-pointer bg-gray-50">
                                    {desktopFile ? (
                                        <img src={desktopFile} className='object-cover w-full h-full' alt="Desktop" />
                                    ) : (
                                        <>
                                            <div className="flex flex-col items-center justify-center pt-4 pb-5">
                                                <i className="fi fi-sr-mode-landscape"></i>
                                                <p className="mb-2 text-sm text-gray-500"><span className="font-semibold">Click to upload</span></p>
                                                <p className="text-xs text-gray-500">SVG, PNG, JPG</p>
                                            </div>
                                        </>
                                    )}
                                    <input type="file" name="DesktopImage" onChange={handlechange} className="hidden" accept="image/*" />
                                </label>
                            </div>
                            
                            <div>
                                <label className="block mb-2 text-sm font-medium">Mobile Image</label>
                                <label className="flex flex-col items-center justify-center object-cover w-40 h-40 overflow-hidden border-2 border-gray-300 border-dashed cursor-pointer bg-gray-50">
                                    {mobileFile ? (
                                        <img src={mobileFile} className='object-cover w-full h-full' alt="Mobile" />
                                    ) : (
                                        <>
                                            <div className="flex flex-col items-center justify-center pt-4 pb-5">
                                                <i className="fi fi-sr-mobile"></i>
                                                <p className="mb-2 text-sm text-gray-500"><span className="font-semibold">Click to upload</span></p>
                                                <p className="text-xs text-gray-500">SVG, PNG, JPG</p>
                                            </div>
                                        </>
                                    )}
                                    <input type="file" name="MobileImage" onChange={handlechange} className="hidden" accept="image/*" />
                                </label>
                            </div>
                        </div>
                    </div>

                    <div className='grid grid-cols-1 gap-3 lg:grid-cols-2'>
                        <div className="mb-2">
                            <div className="mb-2">
                                <label>Banner Name</label>
                            </div>
                            <input type="text" name="Banner_Name" value={formdata?.Banner_Name || ''} onChange={handlechange} className="w-full px-4 py-2 border rounded-md outline-none" required/>
                        </div>
                         
                       
                            <div className="mb-2">
                                <div className="mb-2">
                                    <label>Redirect Link</label>
                                </div>
                                <input type="text" name="redirect_link" value={formdata?.redirect_link || ''} onChange={handlechange} className="w-full px-4 py-2 border rounded-md outline-none"/>
                            </div>
                        
                      
                            <div className="mb-2">
                                <div className="mb-2">
                                    <label>Status</label>
                                </div>
                                <select name="Status" value={formdata?.Status || ''} onChange={handlechange} className="w-full px-4 py-2 border rounded-md outline-none" required>
                                    <option value="" disabled>---select a status---</option>
                                    <option value="Active">Active</option>
                                    <option value="Inactive">Inactive</option>
                                </select>
                            </div>
                        </div>

                    <div className="flex justify-end gap-3 mt-4">
                            <button type="button" onClick={() => setVisible(false)} className="px-4 py-1 bg-gray-200 rounded-lg">Cancel</button>
                            <button type="submit" className="px-4 py-1 text-white rounded-lg bg-regal-blue">{!formdata?._id ? "Save" : "Update"}</button>
                        </div>
                </form>
            </Dialog>
        </>
    )
}